<template>
  <div class="main">
     <el-container>
      <el-header style="height: 100%;padding: 0;">
				 <div class = "header-home">
					<div class="b">
					     <img  src="../assets/compay1/logo.png" class="b1">
					     <span class="b2">株式会社　サンシャイン</span>
					     <span class="b3"><hr/></span>
					     <img src="../assets/compay1/cao.png" class="b4">
					     <img src="../assets/compay1/hua.png" class="b5">
					     <img  src="../assets/compay1/ping.png" class="b6">
					     <img  src="../assets/compay1/xiaohua.png" class="b8">
					     <span class="b7">Sunshine  LLC</span>
					</div>
					<div class="a1">
						 <button @click="change">Language</button>
					</div>
          <div class="h">
            <img  src="../assets/compay1/ljz.png" class="h99">
            <img  src="../assets/compay1/ljy.png" class="h11">
          </div>
          <div class="hui">
            <h1 class="hui1">{{ $t("message.company") }}</h1>
            <h1 class="hui2">{{ $t("message.Overview") }}</h1>
            <img  src="../assets/compay1/xiaohua.png" class="hui3">
          </div>
				 </div>
      </el-header>
       <el-main style="height: 100%; padding: 0;">
				 <div class="main-home">
					 <div class="maintitle">
						 <span class="maintitletxt">株式会社　サンシャイン</span>
					 </div>
           <div class="huahua">
            <img  src="../assets/compay1/huahua.png" class="huahua1">
           </div>
					 <div class="g">
					       <div class="context">
									 <div class="context_title1">
										 <h1 class="contextname1">{{ $t("message.Companyname") }}：</h1>
									 </div>
									 <div class="context_titlename2">
										 <h1 class="contextname2">株式会社　サンシャイン</h1>
										 <h1 class="contextname3">Sunshine  LLC</h1>
									 </div>
					       </div>
								 <el-divider class="divider_self"></el-divider>
								 <div class="context-n1">
									 <div class="context_title1">
										 <h1 class="context1">{{ $t("message.Establishmentdate") }}：</h1>
									 </div>
									 <div class="context_title2">
										 <h1 class="context2">2022年8月9日</h1>
									 </div>
								 </div>
								 <el-divider class="divider_self"></el-divider>
								 <div class="context-n1">
									 <div class="context_title1">
										 <h1 class="context1">{{ $t("message.Sukihon") }}：</h1>
									 </div>
									 <div class="context_title2">
										 <h1 class="context2">{{ $t("message.millionyen") }}</h1>
									 </div>
								 </div>
								 <el-divider class="divider_self"></el-divider>
								 <div class="context-n1">
										 <div class="context_title1">
											 <h1 class="context1">{{ $t("message.Atable") }}：</h1>
										 </div>
										 <div class="context_title2">
											 <h1 class="context2">{{ $t("message.Representative") }}</h1>
										 </div>
								 </div>
								 <el-divider class="divider_self"></el-divider>
								 <div class="context-n1">
										 <div class="context_title1">
											 <h1 class="context1">{{ $t("message.benshe") }}：</h1>
										 </div>
										 <div class="context_title2">
											 <h1 class="context2">岐阜県多治見笠原町上原1254番地の1</h1>
										 </div>
								 </div>
								 <el-divider class="divider_self"></el-divider>
								<div class="context-n1">
									 <div class="context_title1">
										 <h1 class="context1">{{ $t("message.dier") }}：</h1>
									 </div>
									 <div class="context_title2">
										 <h1 class="context2">岐阜県多治見市下沢町4-45-3</h1>
									 </div>
								</div>
                <el-divider class="divider_self"></el-divider>
								<div class="context-n1">
									 <div class="context_title1">
										 <h1 class="context1">{{ $t("message.businessOfficeName") }}：</h1>
									 </div>
									 <div class="context_title2">
										 <h1 class="context2">長久手営業所</h1>
									 </div>
								</div>
                <el-divider class="divider_self"></el-divider>
								<div class="context-n1">
									 <div class="context_title1">
										 <h1 class="context1">{{ $t("message.businessOfficeAddress") }}：</h1>
									 </div>
									 <div class="context_title2">
										 <h1 class="context2">愛知県長久手市前熊一ノ井1－1171</h1>
									 </div>
								</div>
								<el-divider class="divider_self"></el-divider>
								<div class="context-n1">
									 <div class="context_title1">
										 <h1 class="context1">T&emsp;E&emsp;L ：</h1>
									 </div>
									 <div class="context_title2">
										 <h1 class="context2">0572-56-5308</h1>
									 </div>
								</div>
								<el-divider class="divider_self"></el-divider>
								<div class="context-n1">
									 <div class="context_title1">
										 <h1 class="context1">F&emsp;A&emsp;X ：</h1>
									 </div>
									 <div class="context_title2">
										 <h1 class="context2">0572-56-5309</h1>
									 </div>
								</div>
								<el-divider class="divider_self"></el-divider>
								<div class="context-n1">
									 <div class="context_title1">
										 <h1 class="context1">Email &emsp;：</h1>
									 </div>
									 <div class="context_title2">
										 <h1 class="context2">info@mail.sunshinejp.jp</h1>
									 </div>
								</div>
								<el-divider class="divider_self"></el-divider>
								<div class="context-n1">
									 <div class="context_title1">
										 <h1 class="context1">{{ $t("message.Businesscontents") }}：</h1>
									 </div>
									 <div class="context_title2">
										 <h1 class="context4">{{ $t("message.Contents1") }}<br>
					 							{{ $t("message.Contents2") }}<br>
					 							{{ $t("message.Contents3") }}<br>
					 							{{ $t("message.Contents4") }}</h1>
									 </div>
								</div>
					  </div>
						<!-- 右侧一排图片 -->
						<div class="sideBoxOs">
							<div class="sideBox">
							    <p class="side">{{ $t("message.productIntroductionp") }}</p>
							    <!-- <hr class="hr"> -->
                  <img  src="../assets/compay1/huahua.png" class="huahua2">
							    <p class="img1"><img src="../assets/picture/zhiwu4.jpg"/></p>
							    <p class="img2"><img src="../assets/picture/12.jpg"/></p>
							    <p class="img3"><img src="../assets/picture/zhonggu3.jpg"/></p>
							    <p class="img4"><img src="../assets/picture/taochi1.jpg"/></p>
							</div>
						</div>
				 </div>
			 </el-main>
       <el-footer>
				 <div class="footer-home">
						<homeFooterVue></homeFooterVue>
				 </div>
			 </el-footer>
     </el-container>
   </div>
</template>

<script>
import homeFooterVue from './home-footer.vue';
	
export default {
  name: 'Home',
	components:{
	  homeFooterVue
	},
	data() {
	    return {}
	},
  methods: {
    change() {
      console.log("this.$i18n.locale");
      if (this.$i18n.locale == "cn") {
        this.$i18n.locale = "jp"; // 切换日文
      } else {
        this.$i18n.locale = "cn"; // 切换中文
      }
     }
  }
}
</script>

<style scoped>
  .main{
    height: 100%; 
    min-width: 1024px;
		width:100%;
		text-align:center;
  }
	  /*头部*/
	.header-home{
		height: 344px;
		min-width: 1024px;
		width: 1400px;
		margin:0 auto;
    background-image:url("../assets/compay1/dabeijing.png" );
    background-size: 1440px 344px;
		position: relative;
	}
	/*中部*/
	.main-home{
		height: 1110px;
		min-width: 1024px;
		width: 1024px;
		margin:0 auto;
		background-color: #F7FCFB;
		position: relative;
	}
	/* .maintitle{
		position: absolute;
		width: 300px;
		height: 50px;
		top: 30px;
		left: 50px;
	} */
	.maintitletxt{
    position: absolute;
		top: 40px;
    left: 70px;
    font-family: PingFangSC-Semibold;
    font-size: 24px;
    color: #3EAE7E;
    text-align: center;
    font-weight: 550;
	  }
    .huahua1{
      position: absolute;
		  width: 100px;
		  height: 100px;
		  top: 10px;
		  left: 40px;
    }
	/*底部*/
	.footer-home{
		height: 100%;
		min-width: 1024px;
		width: 1024px;
		margin:0 auto;
		background-color: blue;
	}
  /*图片背景*/
  .a{
    position: absolute;
    margin: auto; 
    top: 0;
    right: 0;
    bottom:10;
    left: 0; 
    width:1440px;
    height:852px;
    background-image:url("../assets/compay1/xrz.png" );
    background-size: cover;
 }
 /* 语言切换盒子 */
 .a1{
  position: absolute;
  right: 10px;
  top: 5px;
}
/* 语言切换按钮 */
.a1 button{
  border-color: transparent;
  background: #00FF0000;
  /*鼠标变小手*/
  cursor: pointer;
}
  /*左面盒子*/
  .b{
    position:absolute;
    width: 500px;
    height: 150px;
    top:20px;
    left:20px;
  }

  /*图标设置*/
  .b1{
    position:absolute;
    width: 37px;
    height: 37px;
    left:200px;
    top: 3px;
  }
    /*文字设置*/
  .b2{
    font-family: PingFangSC-Regular;
    font-weight: 400;
    position:absolute;
    font-size: 19px;
    color: #000000;
    right:40px;
    /* top:0px; */
    bottom: 130px;
    }
    /*直线设置*/
  .b3{
    position:absolute;
    width: 200px;
    height: 8px;
    color: darkgray;
    top:19px;
    right:48px;
  }
  /*草*/
  .b4{
    position:absolute;
    width: 15px;
    height: 14px;
    top:35px;
    right:235px;
  }

  /*花*/
  .b5{
    position:absolute;
    width: 15px;
    height: 14px;
    top:35px;
    right:210px;
  }
  /*瓶*/
  .b6{
    position:absolute;
    width: 15px;
    height: 14px;
    top:35px;
    right:185px;
  }
  /*英文*/
  .b7{
    font-family: AvenirNext-Regular;
    font-weight: 400;
    position:absolute;
    width: 170px;
    height: 24px;
    font-size: 13px;
    color: #000000;
    top:33px;
    right:5px
  }
   /*实心花*/
  .b8{
    position:absolute;
    width: 15px;
    height: 14px;
    top:35px;
    right:140px;
  }
   /*右面盒子*/
  .c{
    position:absolute;
    width: 500px;
    height: 500px;
    top:140px;
    right:190px;
  }
  /*折线左上图片位置设置*/
  .c1{
    position:absolute;
    width: 125px;
    height: 138px;
    right:360px;
  }
  /*折线右下图片位置设置*/
  .c2{
    position:absolute;
    width: 125px;
    height: 138px;
    top:240px;
    right:90px;
  }

 /*会社文字设置*/
  .c3{
    position:absolute;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 100px;
    color: #000000;
    top:20px;
    right:240px;
  }
  /*会社概要实心花设置*/
  .c4{
    position:absolute;
    width: 19px;
    height: 20px;
    bottom:310px;
    right:280px;
  }
  /*概要文字设置*/
  .c5{
    position:absolute;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 100px;
    color: #000000;
    bottom:150px;
    right:130px;
  }
   /*竖线设置*/
  .c6{
    float: left;
    width: 0.5px;
    height: 330px;
    background: #979797;
    position:absolute;
    top:35px;
    right:30px;
    }
    /*圆设置*/
  .c7{
    position:absolute;
    border-radius:50%;
    width: 18px;
    height: 18px;
    border: 1.1px solid rgba(151,151,151,1);
    top:15px;
    right:22px;
  }
   /*会社概要盒子*/
  .d{
    position:absolute;
    width: 450px;
    height: 200px;
    bottom:90px;
    right:270px;
  }
  /*会社概要文字信息设置*/
  .d1{
    position:absolute;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 14px;
    color: #5F5F5F;
    line-height: 31px;
    font-weight: 400;
    display: inline-block;
    text-align: left;
    right:0px;
  }
   /*图片背景*/
  .e{
    position: absolute;
    margin: auto; 
    top: 20;
    right: 0;
    top: 852px;
    left: 0; 
    width:1440px;
    height:2100px;
    background-image:url("../assets/compay1/jianjian.png" );
    background-size: cover;
 }
 /*上面盒子*/
 .f{
    position:absolute;
		top: 98px;
    right:106px;
 }
 /*花设置*/
 .f1{
    position:absolute;
    width: 170px;
    height: 180px;
    bottom:20px;
    left:30px;
 }
  /*会社概要文字信息设置*/
  .f2{
    writing-mode: vertical-rl;
    position:absolute;
    letter-spacing:9px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 33px;
    color: #3EAE7E;
    line-height: 42px;
    font-weight: 400;
    bottom:22px;
    left:72px;
  }
    /*英文设置*/
  .f3{
    position:absolute;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 25px;
    color: #000000;
    top:110px;
    right:0px;
    font-weight: 400;
  }
   /*横线设置*/
  .f4{
    height: 1px;
    width: 720px;
    background: #979797;
    position:absolute;
    right:5px;
    top:190px;
    }
    /*圆设置*/
  .f5{
    position:absolute;
    border-radius:50%;
    width: 18px;
    height: 18px;
    border: 1px solid rgba(151,151,151,1);
    left:295px;
    top:180px;
  }
  /*会社概要文字设置*/
  /* .f6{
    letter-spacing:2px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 36px;
    color: #000000;
		display: inline-block;
  } */

 /*背景上会社文字设置*/ 
  .hui1{
    position:absolute;
    left: 300px;
    top: 66px;
    font-family: SimSong-Bold;
    font-size: 56px;
    color: #000000;
    text-align: center;
    font-weight: 400;
  }
 /*背景上概要文字设置*/ 
  .hui2{
    position:absolute;
    left: 480px;
    top: 66px;
    font-family: SimSong-Bold;
    font-size: 55px;
    color: #000000;
    text-align: center;
    font-weight: 400;
  }
  /* 会社概要中间的小花 */
  .hui3{
    position:absolute;
    width: 16px;
    height: 16px;
    left: 439px;
    top: 142px;
  }
  
  /* 路径盒子 */
  .h{
    position:absolute;
    left: 235px;
    top: 112px;
  }
  /*会社概要的路径左*/
  .h99{
    position:absolute;
    width: 43px;
    height: 76px;
    bottom: 180px;
    left: 250px;
  }
  /*会社概要的路径右*/
  .h11{
    position:absolute;
    width: 43px;
    height: 76px;
    bottom: 180px;
    left: 620px;
  }
   /*下面盒子*/
 .g{
    position:absolute;
    width:600px;
    height:870px;
    left:64px;
    top:89px;
 }
 /*社名盒子设置*/
 .gg{
    position:absolute;
    width:600px;
    height:150px;
    left:0px;
    top:60px;
 }
 .sideBoxOs{
	 position:absolute;
	 right:0px;
	 top:0px;
   width: 303px;
   height: 1032px;
 }
  /*社名前实心花设置*/
	.context{
    width:600px;
    height:83px;
		position:relative;
	}
	.context-n1{
	  width:600px;
	  height:40px;
		position:relative;
		margin-top: 20px;
	}
	.context_title1{
		display: inline-block;
		position:absolute;
		left: 0px;
		top: 0px;
	}
	.context_title2{
		display: inline-block;
		position:absolute;
		left: 100px;
		top: 0px;
	}
  /* .context_titlename2{
		display: inline-block;
		position:absolute;
		left: 100px;
		top: 0px;
	} */
	/*社名文字设置*/
	.context1{
		margin-top: 0;
    font-family: PingFangSC-Semibold;
    font-size: 16px;
    color: #000000;
    text-align: center;
    font-weight: 600;
    
	}
  /* 社名文字单独设置 */
  .contextname1{
    margin-top: 40px;
    font-family: PingFangSC-Semibold;
    font-size: 16px;
    color: #000000;
    text-align: center;
    font-weight: 600;
  }
	/*文字设置*/
	.context2{
	  font-family: PingFangSC-Regular;
	  font-weight: 400;
	  letter-spacing:2px;
	  font-size: 15px;
	  color: #726F6F;
		margin-top: 0px;
	  }
    /*文字设置*/
	.contextname2{
    position:absolute;
    top: 30px;
    left: 100px;
	  font-family: PingFangSC-Regular;
	  font-weight: 400;
	  letter-spacing:2px;
	  font-size: 15px;
	  color: #726F6F;
		margin-top: 0px;
	  }
    .contextname3{
    position:absolute;
    top: 55px;
    left: 100px;
	  font-family: PingFangSC-Regular;
	  font-weight: 400;
	  letter-spacing:2px;
	  font-size: 15px;
	  color: #726F6F;
		margin-top: 0px;
	  }
	/*英文设置*/
	.context3{
	  font-family: PingFangSC-Regular;
	  font-weight: 400;
	  letter-spacing:0.5px;
	  font-size: 19px;
	  color: #726F6F;
		text-align: left;
	}
	/*事業内容设置*/
	.context4{
	  font-family: PingFangSC-Regular;
	  font-weight: 400;
	  letter-spacing:2px;
	  line-height: 37px;
	  font-size: 15px;
	  color: #726F6F;
	  display: inline-block;
	  text-align: left;
	  margin: 0px 0px 0px 0px;
	  padding: 0px;
	  }
	.divider_self{
		margin: 2px 0px;
	}
  .g1{
    position:absolute;
    width: 13px;
    height: 14px;
    left:10px;
    top:50px;
  }
  /*社名前竖线设置*/
  .g2{
    width: 8px;
    height: 40px;
    background: #3EAE7E;
    position:absolute;
    left:60px;
    top:38px;
  }
  /*社名文字设置*/
  .g3{
    position:absolute;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 30px;
    color: #000000;
    left:90px;
    top:16px;
  }
  /*文字设置*/
  .g4{
    font-family: PingFangSC-Regular;
    font-weight: 400;
    position:absolute;
    letter-spacing:2px;
    font-size: 19px;
    color: #726F6F;
    left:240px;
    top:33px;
    }

  /*英文设置*/
  .g5{
    font-family: PingFangSC-Regular;
    font-weight: 400;
    position:absolute;
    letter-spacing:0.5px;
    font-size: 19px;
    color: #726F6F;
    left:240px;
    top:80px;
  }

  /*横线设置*/
  .g6{
    position:absolute;
    height: 1px;
    width: 560px;
    opacity: 0.3;
    background: #979797;
    left:20px;
    top:140px;
    }
    /*圆设置*/
  .g7{
    position:absolute;
    border-radius:50%;
    width: 12px;
    height: 12px;
    opacity: 0.3;
    border: 1px solid rgba(151,151,151,1);
    right:6px;
    top:134px;
  }
    /*圆设置*/
  .g8{
    position:absolute;
    border-radius:80%;
    width: 12px;
    height: 12px;
    opacity:0.3;
    border: 1px solid rgba(151,151,151,1);
    left:7px;
    top:134px;
  }
   /*設立日整体位置*/
  .h{
    letter-spacing:10px;
    position:absolute;
    width:600px;
    height:150px;
    left:0px;
    top:220px;
 }
  /*設立日前实心花设置*/
  .hh1{
    position:absolute;
    width: 13px;
    height: 14px;
    left:10px;
    top:50px;
  }
  /*設立日前竖线设置*/
  .hh2{
    width: 8px;
    height: 40px;
    background: #3EAE7E;
    position:absolute;
    left:60px;
    top:38px;
  }
  /*設立日文字设置*/
  .hh3{
    position:absolute;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 30px;
    color: #000000;
    left:90px;
    top:16px;
  }
    /*日期文字设置*/
  .hh4{
    font-family: PingFangSC-Regular;
    font-weight: 400;
    position:absolute;
    letter-spacing:2px;
    font-size: 19px;
    color: #726F6F;
    left:240px;
    top:33px;
    }
  /*横线设置*/
  .hh5{
    position:absolute;
    height: 1px;
    width: 560px;
    opacity: 0.3;
    background: #979797;
    left:20px;
    top:140px;
    }
    /*圆设置*/
  .hh6{
    position:absolute;
    border-radius:50%;
    width: 12px;
    height: 12px;
    opacity: 0.3;
    border: 1px solid rgba(151,151,151,1);
    right:6px;
    top:133px;
  }
    /*圆设置*/
  .hh7{
    position:absolute;
    border-radius:80%;
    width: 12px;
    height: 12px;
    opacity:0.3;
    border: 1px solid rgba(151,151,151,1);
    left:7px;
    top:133px;
  }
  /*資本金整体设置*/ 
  .j{
    position:absolute;
    width:600px;
    height:150px;
    left:0px;
    top:380px;
 }
  /*資本金前实心花设置*/
  .j1{
    position:absolute;
    width: 13px;
    height: 14px;
    left:10px;
    top:50px;
  }
  /*資本金前竖线设置*/
  .j2{
    width: 8px;
    height: 40px;
    background: #3EAE7E;
    position:absolute;
    left:60px;
    top:38px;
  }
   /*資本金文字设置*/
  .j3{
    letter-spacing:10px;
    position:absolute;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 30px;
    color: #000000;
    left:90px;
    top:16px;
  }
  /*資本金数字设置*/
  .j4{
    font-family: PingFangSC-Regular;
    font-weight: 400;
    position:absolute;
    letter-spacing:2px;
    font-size: 19px;
    color: #726F6F;
    left:240px;
    top:33px;
    }
  /*横线设置*/
  .j5{
    position:absolute;
    height: 1px;
    width: 560px;
    opacity: 0.3;
    background: #979797;
    left:20px;
    top:140px;
    }
    /*圆设置*/
  .j6{
    position:absolute;
    border-radius:50%;
    width: 12px;
    height: 12px;
    opacity: 0.3;
    border: 1px solid rgba(151,151,151,1);
    right:6px;
    top:133px;
  }
    /*圆设置*/
  .j7{
    position:absolute;
    border-radius:80%;
    width: 12px;
    height: 12px;
    opacity:0.3;
    border: 1px solid rgba(151,151,151,1);
    left:7px;
    top:133px;
  }
    /*代表者整体位置*/
  .k{
    position:absolute;
    width:600px;
    height:150px;
    left:0px;
    top:540px;
 }
 /*代表者前实心花设置*/
  .k1{
    position:absolute;
    width: 13px;
    height: 14px;
    left:10px;
    top:50px;
  }
   /*代表者前竖线设置*/
  .k2{
    width: 8px;
    height: 40px;
    background: #3EAE7E;
    position:absolute;
    left:60px;
    top:38px;
  }
  /*代表者文字设置*/
  .k3{
    letter-spacing:10px;
    position:absolute;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 30px;
    color: #000000;
    left:90px;
    top:16px;
  }
   /*代表取締役包海文字设置*/
  .k4{
    font-family: PingFangSC-Regular;
    font-weight: 400;
    position:absolute;
    letter-spacing:2px;
    font-size: 19px;
    color: #726F6F;
    left:240px;
    top:33px;
    }
  /*横线设置*/
  .k5{
    position:absolute;
    height: 1px;
    width: 560px;
    opacity: 0.3;
    background: #979797;
    left:20px;
    top:140px;
    }
    /*圆设置*/
  .k6{
    position:absolute;
    border-radius:50%;
    width: 12px;
    height: 12px;
    opacity: 0.3;
    border: 1px solid rgba(151,151,151,1);
    right:6px;
    top:133px;
  }
    /*圆设置*/
  .k7{
    position:absolute;
    border-radius:80%;
    width: 12px;
    height: 12px;
    opacity:0.3;
    border: 1px solid rgba(151,151,151,1);
    left:7px;
    top:133px;
  }
   /*本社仓库整体位置*/
  .l{
    position:absolute;
    width:600px;
    height:150px;
    left:0px;
    top:700px;
 }
 /*本社仓库前实心花设置*/
  .l1{
    position:absolute;
    width: 13px;
    height: 14px;
    left:1px;
    top:50px;
  }
  /*本社仓库前竖线设置*/
  .l2{
    width: 8px;
    height: 25px;
    background: #3EAE7E;
    position:absolute;
    left:24px;
    top:43px;
  }
  /*本社仓库文字设置*/
  .l3{
    position:absolute;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 30px;
    color: #000000;
    left:90px;
    top:16px;
  }
  /*本社仓库名字文字设置*/
  .l4{
    font-family: PingFangSC-Regular;
    font-weight: 400;
    position:absolute;
    letter-spacing:2px;
    font-size: 19px;
    color: #726F6F;
    left:240px;
    top:33px;
    }
  /*横线设置*/
  .l5{
    position:absolute;
    height: 1px;
    width: 560px;
    opacity: 0.3;
    background: #979797;
    left:20px;
    top:140px;
    }
    /*圆设置*/
  .l6{
    position:absolute;
    border-radius:50%;
    width: 12px;
    height: 12px;
    opacity: 0.3;
    border: 1px solid rgba(151,151,151,1);
    right:6px;
    top:133px;
  }
    /*圆设置*/
  .l7{
    position:absolute;
    border-radius:80%;
    width: 12px;
    height: 12px;
    opacity:0.3;
    border: 1px solid rgba(151,151,151,1);
    left:7px;
    top:133px;
  }
  /*第二仓库整体位置*/
  .i{
    position:absolute;
    width:600px;
    height:150px;
    left:0px;
    top:855px;
 }
 /*第二仓库前实心花设置*/
  .i1{
    position:absolute;
    width: 13px;
    height: 14px;
    left:10px;
    top:50px;
  }
  /*第二仓库前竖线设置*/
  .i2{
    width: 8px;
    height: 40px;
    background: #3EAE7E;
    position:absolute;
    left:60px;
    top:38px;
  }
  /*第二仓库文字设置*/
  .i3{
    position:absolute;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 30px;
    color: #000000;
    left:90px;
    top:16px;
  }
  /*第二仓库名字文字设置*/
  .i4{
    font-family: PingFangSC-Regular;
    font-weight: 400;
    position:absolute;
    letter-spacing:2px;
    font-size: 19px;
    color: #726F6F;
    left:240px;
    top:33px;
    }
  /*横线设置*/
  .i5{
    position:absolute;
    height: 1px;
    width: 560px;
    opacity: 0.3;
    background: #979797;
    left:20px;
    top:140px;
    }
    /*圆设置*/
  .i6{
    position:absolute;
    border-radius:50%;
    width: 12px;
    height: 12px;
    opacity: 0.3;
    border: 1px solid rgba(151,151,151,1);
    right:6px;
    top:133px;
  }
    /*圆设置*/
  .i7{
    position:absolute;
    border-radius:80%;
    width: 12px;
    height: 12px;
    opacity:0.3;
    border: 1px solid rgba(151,151,151,1);
    left:7px;
    top:133px;
  }
  /*事業内容整体位置*/
  .z{
    position:absolute;
    width:600px;
    height:280px;
    left:0px;
    top:1440px;
 }
  /*事業内容前实心花设置*/
  .z1{
    position:absolute;
    width: 13px;
    height: 14px;
    left:10px;
    top:50px;
  }
    /*事業内容前竖线设置*/
  .z2{
    width: 8px;
    height: 40px;
    background: #3EAE7E;
    position:absolute;
    left:60px;
    top:38px;
  }
   /*事業内容文字设置*/
  .z3{
    letter-spacing:2px;
    position:absolute;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 30px;
    color: #000000;
    left:90px;
    top:16px;
  }
  /*事業内容设置*/
  .z4{
    font-family: PingFangSC-Regular;
    font-weight: 400;
    position:absolute;
    letter-spacing:2px;
    line-height: 37px;
    font-size: 19px;
    color: #726F6F;
    left:130px;
    top:41px;
    display: inline-block;
    text-align: left;
    margin: 0px 0px 0px 120px;
    padding: 0px;
    }
  /*横线设置*/
  .z5{
    position:absolute;
    height: 1px;
    width: 560px;
    opacity: 0.3;
    background: #979797;
    left:20px;
    top:270px;
    }
    /*圆设置*/
  .z6{
    position:absolute;
    border-radius:50%;
    width: 12px;
    height: 12px;
    opacity: 0.3;
    border: 1px solid rgba(151,151,151,1);
    right:6px;
    top:263px;
  }
    /*圆设置*/
  .z7{
    position:absolute;
    border-radius:80%;
    width: 12px;
    height: 12px;
    opacity:0.3;
    border: 1px solid rgba(151,151,151,1);
    left:7px;
    top:263px;
  }
	/*TEL整体位置*/
	 .tel{
	   position:absolute;
	   width:600px;
	   height:150px;
	   left:0px;
	   top:1005px;
	}
	/*fax整体位置*/
	 .fax{
	   position:absolute;
	   width:600px;
	   height:150px;
	   left:0px;
	   top:1148px;
	}

	/*email整体位置*/
	 .email{
	   position:absolute;
     letter-spacing:1px;
	   width:600px;
	   height:150px;
	   left:0px;
	   top:1295px;
	}

  /* 右侧图片大框 */
  .sideBox {
   position: relative;
   background: #F0FDF8;
   width: 303px;
   height: 1032px;
}
/* 右侧图片框里面的字 */
.side{
  position:absolute;
  left: 103px;
  top: 10px;
  font-family: PingFangSC-Regular;
  font-weight: 600;
  font-size: 23px;
  color: #3EAE7E;    
}
.huahua2{
  position:absolute;
  top: 10px;
  left: 110px;
  width: 76px;
  height: 80px;
}
/* 右侧图片的虚线 */
.hr{
  border:1px dashed rgb(207, 205, 205);
  width: 258px;
}
/* 右侧图片1 */
.img1 img{
  position:absolute;
  left: 10px;
  top: 115px;
  width: 270px;
  height: 210px;
  border-radius:15px;
  border: 1px solid green;
}
/* 右侧图片2 */
.img2 img{
  position:absolute;
  left: 10px;
  top: 350px;
  width: 270px;
  height: 210px;
  border-radius:15px;
  border: 1px solid green;
}
/* 右侧图片3 */
.img3 img{
  position:absolute;
  left: 10px;
  bottom: 235px;
  width: 270px;
  height: 210px;
  border-radius:15px;
  border: 1px solid green;
}
/* 右侧图片4 */
.img4 img{
  position:absolute;
  left: 10px;
  bottom: 1px;
  width: 270px;
  height: 210px;
  border-radius:15px;
  border: 1px solid green;
}
/* 右侧图片5 */
.img5 img{
  width: 250px;
  height: 170px;
}
/* 右侧图片6 */
.img6 img{
  width: 250px;
  height: 170px;
}
   /*回到图标大小顶部*/
  .x1{
    width: 52px;
    height: 47px;
  }
  /*回到顶部*/
.el-backtop {
    position: fixed;
    width: 0px;
    height: 0px; 
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    cursor: pointer;
    z-index: 5;
}


</style>